import { useIsSmOrSmaller } from '@dreamstack/feature-components/src/hooks/useWindowSize'
import dynamic from 'next/dynamic'
import type { FunctionComponent } from 'react'
import { useGraphFontsizeCb } from './HomeOwnershipReport/useGraphFontsize'
import { useGetFormattedToLocal } from './RegionGraphs/libs/useGetFormattedToLocal'

const ResponsivePie = dynamic(
  () => import('@nivo/pie').then((mod) => mod.ResponsivePie),
  {
    ssr: false,
  }
)

type PieChartDataPoint = {
  id: string
  label: string
  value: number
}

interface PieChartProps {
  data: PieChartDataPoint[]
  colors: string[]
  labelsAreRight?: boolean
}

export const PieChart: FunctionComponent<
  React.PropsWithChildren<PieChartProps>
> = ({ data, colors, labelsAreRight }) => {
  const formatToLocale = useGetFormattedToLocal()
  const graphFontSize = useGraphFontsizeCb()
  const isMobile = useIsSmOrSmaller()
  const margin = isMobile
    ? { top: 40, right: 60, bottom: 40, left: 60 }
    : {
        top: 100,
        right: 150,
        bottom: 130,
        left: 150,
      }
  const offsetLegendsLeft = isMobile ? -30 : -130

  const offsetLegendsRight = isMobile ? 30 : 130

  return (
    <ResponsivePie
      data={data}
      theme={{
        text: {
          fontSize: graphFontSize(),
          fontFamily: 'Montserrat',
        },
      }}
      padAngle={4}
      innerRadius={0.05}
      margin={margin}
      sortByValue={false}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      enableArcLabels={false}
      arcLabel={(val) => formatToLocale(val.value)}
      arcLabelsTextColor="white"
      arcLinkLabelsThickness={3}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 0.2]],
      }}
      enableArcLinkLabels={false}
      legends={[
        {
          anchor: !!labelsAreRight ? 'top-right' : 'top-left',
          direction: 'column',
          justify: false,
          translateX: !!labelsAreRight ? offsetLegendsRight : offsetLegendsLeft,
          translateY: isMobile ? -20 : -70,
          itemsSpacing: 5,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: '#999',
          itemDirection: !!labelsAreRight ? 'right-to-left' : 'left-to-right',
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
      colors={colors}
    />
  )
}
